import { Injectable } from '@angular/core';
import { IconType } from '@shared/utils/icons';
import { MenuItemsService, NavbarHeaderMenuItem, NavbarMenuItem } from '@shared/utils/menu-items';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MockMenuItemsService extends MenuItemsService {
  constructor() {
    super();
  }

  initializeMenuService(): void {}

  getHeaderMenuItems(): Observable<NavbarHeaderMenuItem[]> {
    return of([]);
  }

  getMenuItems(): Observable<NavbarMenuItem[]> {
    return of([
      new NavbarMenuItem({
        label: 'Agency',
        icon: IconType.Building,
        routerLink: '/te',
        items: [
          new NavbarMenuItem({ label: 'Create', icon: IconType.Camera, routerLink: '/agency/create' }),
          new NavbarMenuItem({ label: 'List', icon: IconType.Camera, routerLink: '/agency/list' }),
        ],
      }),
      new NavbarMenuItem({
        label: 'Evidence',
        icon: IconType.Tags,
        routerLink: '/te',
        items: [new NavbarMenuItem({ label: 'Restore', icon: IconType.Camera, routerLink: '/evidence/restore' })],
      }),
    ]);
  }

  onDestroy(): void {}
}
